module.exports = __webpack_public_path__ + "media/images/lgt/gallery2-3f6255daa4534c3c3ba7ff21b258d314.jpg";